/**
 * Pluralizes word
 * @param noun word to pluralize
 * @param count the count of @param noun
 * @returns a pluralized @param noun depending on the value of @param count
 */
export const pluralize = (noun: string, count: number) => {
	return count === 1 ? noun : `${noun}s`;
};
